var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSegmented(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12,
    fill: "#D8ECFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_514_474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6001 45.8826C40.3356 45.8826 46.6064 39.7855 46.6064 32.2643C46.6064 24.7431 40.3356 18.646 32.6001 18.646C24.8646 18.646 18.5938 24.7431 18.5938 32.2643C18.5938 39.7855 24.8646 45.8826 32.6001 45.8826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.231 12.9434H17.7682C16.2226 12.9434 14.9697 14.1616 14.9697 15.6643V49.3336C14.9697 50.8364 16.2226 52.0546 17.7682 52.0546H46.231C47.7765 52.0546 49.0295 50.8364 49.0295 49.3336V15.6643C49.0295 14.1616 47.7765 12.9434 46.231 12.9434Z",
    stroke: "#0561FC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.293 29.083C28.0463 29.083 23.7996 29.083 19.5506 29.083C18.4942 29.083 17.8109 28.2259 18.1467 27.328C18.3426 26.7997 18.7484 26.5095 19.3197 26.446C19.4456 26.4324 19.5739 26.4392 19.7022 26.4392C28.1256 26.4392 36.549 26.4392 44.9724 26.4392C45.1683 26.4392 45.3735 26.4369 45.5624 26.48C46.2317 26.6342 46.6678 27.2441 46.6001 27.8972C46.5325 28.5479 45.9798 29.0558 45.2895 29.0785C44.8791 29.0921 44.4686 29.083 44.0582 29.083C40.1357 29.083 36.2155 29.083 32.293 29.083Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7467 39.6561C27.2113 39.6561 23.6759 39.6606 20.1405 39.6561C18.655 39.6538 17.6779 38.7491 18.2049 37.8625C18.5221 37.3274 19.1354 37.0349 19.989 37.0168C20.7002 37.0009 21.4115 37.0122 22.1228 37.0122C28.4427 37.0122 34.7602 37.0122 41.0801 37.0122C41.3623 37.0122 41.6561 37.01 41.9266 37.053C42.8851 37.2072 43.5148 37.8172 43.4168 38.4702C43.3165 39.1504 42.4887 39.6515 41.4136 39.6538C38.2443 39.6606 35.075 39.6561 31.9034 39.6561C31.5163 39.6561 31.1315 39.6561 30.7444 39.6561H30.7467Z",
    fill: "#0561FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7424 31.7246C34.2778 31.7246 37.8132 31.7224 41.3486 31.7246C42.5193 31.7246 43.3822 32.262 43.4242 32.9899C43.4661 33.7313 42.6289 34.339 41.5119 34.364C40.8822 34.3776 40.2526 34.3662 39.6229 34.3662C33.1421 34.3662 26.659 34.3662 20.1782 34.3662C18.6554 34.3662 17.6759 33.457 18.2076 32.5568C18.5201 32.0285 19.2314 31.7246 20.1969 31.7246C23.7113 31.7246 27.228 31.7246 30.7424 31.7246Z",
    fill: "#0561FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_514_474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 41,
    fill: "white",
    transform: "translate(14 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmented);
export default __webpack_public_path__ + "static/media/segmented.9e192221cb0c3ce82647165ee54f4439.svg";
export { ForwardRef as ReactComponent };